import { useMemo } from 'react';

import appStore from '@Stores/app';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Publisher',
    entityNamePlural: 'Publishers',
    entityNameModule: 'offer',
    filters: { active: true },
    defaultParams: {
      organizationId: appStore.site.organizationId,
    },
  }), [])
}
